import PropTypes from 'prop-types';
import { shuffle } from 'lodash';
import { useEffect, useState } from 'react';
import LoadingAnimationBase from './LoadingAnimationBase';

//Webm is for windows/chrome/edge/firefox mp4 is for Apple/Safari (mp4 is H.265 and alpha channel is used to make background transparent)

const loaderVids = [
  // classic
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1771515944/Loading%20Gifs/Platform_Solutions_GIF_04_Plants_001_qssnoy.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1773241710/Loading%20Gifs/Platform_Solutions_GIF_04_Plants_001_qssnoy_vrjzr0.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1771517988/Loading%20Gifs/videoframe_3693_gxidbw.png",
    season: "classic"
  },
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1771517021/Loading%20Gifs/Platform_Solutions_GIF_05_Rocking_Chairs_001_pvq1eb.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1773241711/Loading%20Gifs/Platform_Solutions_GIF_05_Rocking_Chairs_001_1_g7nfiy.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1771518513/Loading%20Gifs/videoframe_0_zj2lsn.png",
    season: "classic"
  },
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1773316971/Loading%20Gifs/Platform_Solutions_GIF_06_Violin_001_1_itha8b.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1773317357/Loading%20Gifs/Platform_Solutions_GIF_06_Violin_001_1_fofjxg.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1773317259/Loading%20Gifs/627f8b42-a3e6-4079-ae34-a967c1cbb896.png",
    season: "classic"
  },
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1774551270/Loading%20Gifs/Platform_Solutions_GIF_09_Janga_001_1_suxvdw.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1774551270/Loading%20Gifs/Platform_Solutions_GIF_09_Janga_001_1_j7v5uk.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1774551429/Loading%20Gifs/videoframe_0_gto2a6.png",
    season: "classic"
  },
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1774627825/Loading%20Gifs/Platform_Solutions_GIF_10_Clock_001_sh0tgd.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1774627825/Loading%20Gifs/Platform_Solutions_GIF_10_Clock_001_ua6cbp.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1774627852/Loading%20Gifs/videoframe_0_1_pfgoek.png",
    season: "classic"
  },
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1774630121/Loading%20Gifs/Platform_Solutions_GIF_08_Magazine_002_ep8rgf.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1774630121/Loading%20Gifs/Platform_Solutions_GIF_08_Magazine_002_uu4fst.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1774630154/Loading%20Gifs/videoframe_0_2_tfkjk4.png",
    season: "classic"
  },
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1781008910/Loading%20Gifs/Platform_Solutions_GIF_16__FryingEgg_001_wanben.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1781008909/Loading%20Gifs/Platform_Solutions_GIF_16__FryingEgg_001_xmrctw.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1781008910/Loading%20Gifs/egg_fry_hhtupo.png",
    season: "classic"
  },
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1781091495/Loading%20Gifs/Platform_Solutions_GIF_15__Pushups_002_cepoxf.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1781091495/Loading%20Gifs/Platform_Solutions_GIF_15__Pushups_002_ph6ara.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1781091495/Loading%20Gifs/pushup_uklu2i.png",
    season: "classic"
  },
  // summer
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1773316978/Loading%20Gifs/Platform_Solutions_GIF_07_Basketball_001_1_atqrcg.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1773317358/Loading%20Gifs/Platform_Solutions_GIF_07_Basketball_001_1_fmvjks.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1773317167/Loading%20Gifs/dc005706-03f5-4e1b-a4b7-376853bf2b32.png",
    season: "summer"
  },
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1776252722/Loading%20Gifs/Platform_Solutions_GIF_12_Golf_002_opdh9g.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1776252722/Loading%20Gifs/Platform_Solutions_GIF_12_Golf_002_qjddq0.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1776252764/Loading%20Gifs/videoframe_0_3_endy6t.png",
    season: "summer"
  },
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1776795398/Loading%20Gifs/Platform_Solutions_GIF_13__Marshmallow_002_uhohog.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1776795397/Loading%20Gifs/Platform_Solutions_GIF_13__Marshmallow_002_plt49n.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1776795461/Loading%20Gifs/videoframe_0_5_qvdknm.png",
    season: "summer"
  },
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1777549551/Loading%20Gifs/Platform_Solutions_GIF_14__Fishing_004_1_1_nyv68l.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1777301089/Loading%20Gifs/Platform_Solutions_GIF_14__Fishing_004_uhoizw.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1781009069/Loading%20Gifs/fishing_k27h3u.png",
    season: "summer"
  },
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1785239420/Loading%20Gifs/Platform_Solutions_GIF_18_Lemonade_001_w0t1hd.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1785239420/Loading%20Gifs/Platform_Solutions_GIF_18_Lemonade_001_gy59de.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1785239537/Loading%20Gifs/Lemonade_Loader_xanmjt.png",
    season: "summer"
  },
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1787059427/Loading%20Gifs/Platform_Solutions_GIF_19_Soccer_002_jgiegw.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1787059437/Loading%20Gifs/Platform_Solutions_GIF_19_Soccer_002_1_qdzwka.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1787062534/Loading%20Gifs/Soccer_Loader_jtchug.png",
    season: "summer"
  },
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1787059428/Loading%20Gifs/Platform_Solutions_GIF_17_Flag_002_pyegnp.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1787059436/Loading%20Gifs/Platform_Solutions_GIF_17_Flag_002_gxxxdf.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1787062533/Loading%20Gifs/Flag_Loader_habgav.png",
    season: "summer"
  },
  // autumn
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1792082804/Loading%20Gifs/Platform_Solutions_GIF_21_Autumn_001_ozjnya.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1792082804/Loading%20Gifs/Platform_Solutions_GIF_21_Autumn_001_vxp6lv.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1792112713/Loading%20Gifs/Autumn_ix0y2t.png",
    season: "autumn"
  },
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1792082805/Loading%20Gifs/Platform_Solutions_GIF_23_Leaf_Blower_001_mevcuf.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1792082805/Loading%20Gifs/Platform_Solutions_GIF_23_Leaf_Blower_001_jlk9fk.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1792112714/Loading%20Gifs/Leaf_Blower_neisce.png",
    season: "autumn"
  },
  // winter
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1792082804/Loading%20Gifs/Platform_Solutions_GIF_20_Snowman_001_k5ylnh.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1792082805/Loading%20Gifs/Platform_Solutions_GIF_20_Snowman_001_oaswy0.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1792112713/Loading%20Gifs/Snowman_o2qwu8.png",
    season: "winter"
  },
  {
    vid: "https://res.cloudinary.com/agoraserv/video/upload/v1792082804/Loading%20Gifs/Platform_Solutions_GIF_22_Snowboard_003_ksjsro.webm",
    vidmp4: "https://res.cloudinary.com/agoraserv/video/upload/v1792082804/Loading%20Gifs/Platform_Solutions_GIF_22_Snowboard_003_mlqokp.mp4",
    poster: "https://res.cloudinary.com/agoraserv/image/upload/v1792112714/Loading%20Gifs/Snowboard_i7hfk7.png",
    season: "winter"
  }
];

const getCurrentSeason = () => {
  const month = new Date().getMonth();
  if (month >= 3 && month <= 7) return "summer"; // April 1 - August 31
  if (month >= 8 && month <= 9) return "autumn"; // September 1 - October 31
  return "winter"; // November 1 - March 31
};

let loaders = [];
let loaderIndex = 0;

const classicLoaders = loaderVids.filter(loader => loader.season === "classic");

const shuffleLoaders = () => {
  const classicLoadersToDisplay = shuffle(classicLoaders).slice(0, 2);
  const currentSeasonLoaders = loaderVids.filter(loader => loader.season === getCurrentSeason());
  loaders = shuffle([...currentSeasonLoaders, ...classicLoadersToDisplay]);
};

LoadingAnimation.propTypes = { wrapperSX: PropTypes.object };

export default function LoadingAnimation({ wrapperSX = { display: "flex", justifyContent: "center" } }) {
  const [loaderVid, setLoaderVid] = useState(null);

  useEffect(() => {
    if (loaderIndex >= loaders.length) {
      shuffleLoaders();
      loaderIndex = 0;
    }
    const vid = loaders[loaderIndex];
    setLoaderVid(vid);
    loaderIndex++;
  }, []);

  return (loaderVid && <LoadingAnimationBase vid={loaderVid.vid} poster={loaderVid.poster} vidmp4={loaderVid.vidmp4} wrapperSX={wrapperSX} />);
};
